import Iframe from 'react-iframe';
import React from 'react'; 
import { Card, Elevation } from '@blueprintjs/core';

export default function Carteira() {
    return (
        
        <Iframe 
        url="https://app.powerbi.com/view?r=eyJrIjoiN2JiNGJjODItZjA5Mi00MGZhLTkzZjEtN2M4MDA0MDYyNTI5IiwidCI6ImI1YWE5OTgzLWYxZGMtNGU4MS1iZjllLTQ5Yjk1YmI3ZDIzYyJ9&pageName=ReportSectionf183fa9204c0c5106dad"
        width="1950px"
        height="100%"
        position="absolute"
        allow="fullscreen"
        frameBorder={0}
        allowFullScreen={true}
        />
     
    )
}